import { Avatar, ListItemText, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import { useSelector } from "react-redux";
import React from "react";
import { IReduxState } from "../../store";
import { SITEWEB_SERVER_BASE_URL } from "../../util/apiClient";
import Badge from '@mui/material/Badge';
import { IEnseignantItem } from "../../store/focusEcoleSlice";
import './styleUrne.css';

export interface IListeProps {
  winner: IEnseignantItem | undefined;
}

const Urne = (props: IListeProps) => {
  const { choising } = useSelector((state: IReduxState) => state.focusEcole);
  const { winner } = props


  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center"
        }}
      >
        <Box
          style={{
            width: "50%",
            height: "250px",
            background: `${choising || winner ? "aliceblue" : "url('/img/urneImage.jpeg')"}`, // Utilisez la propriété background et l'URL de l'image
            backgroundSize: 'cover', // Ajustez la taille de l'image
            borderRadius: choising ? 500 : 100,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          className={`${choising ? "box-turned" : ""}`}
        >
          {winner && <img
            src={"/img/download.jpeg"}
            style={{ width: "50%", height: "auto", borderRadius: 10 }}
          />}
        </Box>
      </div>
    </>

  );
};
export default Urne;
